import EntityBase from '@/data/EntityBase';

export default class TemplateState extends EntityBase({
  shifts: null,
  strategy: null,
}) {}
